import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Button, Col, Form, Row } from "react-bootstrap";
import { CardBody } from "reactstrap";
import {
  checkButtonAccess,
  getEntityId,
  getEntityType,
  getOrgId,
} from "../../../Utils/CommonUtils";
import {
  resetFormState,
  setSelectValidError,
  verifyModal,
} from "../../../slices/common/reducer";
import {
  CompanyModalLayoutJSON,
  InformationModalLayoutJSON,
  PrimaryModalLayoutJSON,
  UploadLayoutJSON,
} from "./Json/InformationLayoutJson";
import { renderElement } from "../../../Components/Common/FormRendererV2/Renderer";
import CommonButton from "../../../Components/Common/CommonButton/CommonButton";
import ConfirmationModal from "./Modal/ConfimationModal";
import { getData, updateInformation } from "./InformationService";
import { getSwitchDropdown } from "../../../Utils/CommonService";
import Fieldset from "../../../Components/Common/Fieldset/Fieldset";
import {
  CompanyDetailsFieldsJSON,
  InformationFieldsJSON,
  PrimaryDetailsFieldsJSON,
  UploadFieldsJSON,
} from "./Json/InformationFieldsJson";
import DocumentUploader from "../../../Components/Common/Documents/Documents";
import HubDocuments from "../../../Components/Common/Documents/HubDocuments";

const Details = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const navigator = useNavigate();
  const data = useSelector((state) => state.information.detailsData);
  const dropdownData = useSelector((state) => state.header.dropdownData);
  const verifyShow = useSelector((state) => state.common.verifyShow);
  const triggerRender = useSelector((state) => state.common.triggerRender);
  const selectedUser = useSelector((state) => state.header.selectedUser);

  const editMode = !!params.id;

  const informationFieldJson = useSelector(
    (state) => state.information.informationFieldJson
  );
  const formState = useSelector((state) => state.common.formRendererState);
  const entityType = selectedUser.entitytype;
  const entityId = selectedUser.entityid;
  const [isEditing, setIsEditing] = useState({});
  const [filesFetched, setFilesFetched] = useState(false); // Track when files are fetched
  const files = useSelector(
    (state) => state.information.detailsData.files || {}
  );
  const [files1, setFiles] = useState({});

  const toggleEdit = (fieldKey) => {
    setIsEditing((prev) => ({
      ...prev,
      [fieldKey]: !prev[fieldKey],
    }));
  };

  useEffect(() => {
    // Fetch data and update filesFetched once the data is retrieved
    const fetchData = async () => {
      await getData(entityId, entityType);
      setFilesFetched(true);
    };

    fetchData();
  }, [entityId, entityType]);

  const handleCancel = () => {
    dispatch(resetFormState());
    dispatch(setSelectValidError(false));
    // navigator("/agmember/member");
  };

  const updateClickHandler = (e) => {
    e.preventDefault();
    dispatch(verifyModal(true));
  };

  const confirmUpdate = async () => {
    if (formState) {
      dispatch(setSelectValidError(false));
      const response = await updateInformation(
        formState,
        entityId,
        entityType,
        navigator
      );

      if (response && response.status === 200) {
        // await getData(entityId, entityType);
        setTimeout(() => {
          getData(entityId, entityType);
          console.log("Files after update:", files);
        }, 1000); // Adjust the timeout duration as needed (e.g., 1000ms = 1 second)
      }
    } else {
      dispatch(setSelectValidError(true));
    }
    dispatch(verifyModal(false));
  };

  return (
    <div>
      <Form onSubmit={updateClickHandler}>
        <CardBody>
          <div className="selected-tab-bottom-content">
            {InformationModalLayoutJSON.map((element) => (
              <div key={element.elementid}>
                {element.child.map((child) =>
                  renderElement(child, InformationFieldsJSON, formState)
                )}
              </div>
            ))}
          </div>
          <div className="form-footer">
            <CommonButton
              save={true}
              handleCancel={handleCancel}
              checkAccess={checkButtonAccess("EDIT", "HUB_INFO")}
            />
          </div>
          {verifyShow && <ConfirmationModal confirmUpdate={confirmUpdate} />}
        </CardBody>
      </Form>
    </div>
  );
};

export default Details;
